export function formatExchangeRate(
  value: number,
  locale: string = 'en-US'
): string {
  const numericValue = Number(value);
  if (!Number.isFinite(numericValue)) return '0';

  return numericValue.toLocaleString(locale, {
    useGrouping: false,
    maximumFractionDigits: 20,
  });
}
